module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-1-taybridge-road"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "aberfeldy-perthshire-scotland"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Since then, I have more often climbed the ladder leading from the first floor to the loft. There, a skylight opens to the view in the opposite direction. At the window, I look down the valley of the Tay, seeing the Highlands descend towards Scotland’s eastern seaboard. On a dreamy summer day, when the sun on the slates of the roof warms the loft, a light mist often softens the view. In my mind, I see through the haze the North Sea and, afar, the line of a shore. It shows few features other than the church towers of numerous villages, many towns and a few not very large cities – all set in a flat landscape. In one of these cities I was born, on the twenty fourth day of October 1930.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9cba60a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0017.vue
// module id = 111
// module chunks = 0